import ExternalLink from 'components/ExternalLink/ExternalLink'
import { getExplorerUrl, HYPEREVM } from 'config/chains'
import cx from 'classnames'
import { ImSpinner2 } from 'react-icons/im'
import useWallet from 'rfx/lib/wallets/useWallet'
import commonStore from '@store/commonStore'
import { useEffect, useState } from 'react'

export type TransactionStatusType = 'muted' | 'loading' | 'success' | 'error'

type Props = {
  status: TransactionStatusType
  text: string
  txnHash?: string
  key?: string
  orderStatus?: any
}

export function ExecutionTransactionStatus({
  status,
  text,
  txnHash,
  orderStatus,
}: Props) {
  const { chainId, account } = useWallet()

  const data = commonStore((state) => state.messages)
  const [showCongestionMsg, setShowCongestionMsg] = useState(false)

  // ⏳ start timer if still loading
  useEffect(() => {
    if (status === 'loading' && chainId === HYPEREVM) {
      const timer = setTimeout(() => {
        setShowCongestionMsg(true)
      }, 5000) // 5 seconds
      return () => clearTimeout(timer)
    } else {
      setShowCongestionMsg(false)
    }
  }, [status, chainId])

  const filteredData = data.filter(
    (item) =>
      item.order_owner === account.toLowerCase() &&
      item.order_key === orderStatus?.key,
  )

  const lastTxnData =
    filteredData && filteredData.length > 0
      ? filteredData[filteredData.length - 1]
      : null

  const txnLink = `${getExplorerUrl(chainId)}tx/${txnHash}`
  // eslint-disable-next-line no-console

  return (
    <div>
      {filteredData && filteredData.length > 1 && (
        <div className="mb-4 flex items-start gap-4">
          <div
            className={cx('TransactionStatus-title max-w-[200px]', {
              muted: status === 'muted',
            })}
          >
            Failed to execute transaction using Small Blocks. This will execute
            using Big Blocks.
          </div>
          <div className="TransactionStatus-status mt-1">
            {filteredData[0]?.tx_hash && (
              <ExternalLink
                href={`${getExplorerUrl(chainId)}tx/${filteredData[0]?.tx_hash}`}
                className="text-th-active"
              >
                VIEW
              </ExternalLink>
            )}
          </div>
        </div>
      )}
      <div className="flex items-center gap-4">
        <div
          className={cx('TransactionStatus-title w-[200px] capitalize', {
            muted: status === 'muted',
          })}
        >
          {chainId === HYPEREVM &&
          lastTxnData &&
          lastTxnData?.tx_hash &&
          status !== 'error' &&
          !text.includes('Order cancelled')
            ? text +
              ` using ${lastTxnData?.is_big_block ? 'Big Blocks' : 'Small Blocks'}`
            : text}
        </div>
        <div className="TransactionStatus-status mt-1">
          {status === 'loading' && (
            <div className="flex items-center gap-2">
              {lastTxnData?.tx_hash && (
                <ExternalLink
                  href={`${getExplorerUrl(chainId)}tx/${lastTxnData?.tx_hash}`}
                  className="text-th-active"
                >
                  VIEW
                </ExternalLink>
              )}
              <ImSpinner2
                width={60}
                height={60}
                className="spin TransactionStatus-spin"
              />
            </div>
          )}
          {txnHash && (
            <ExternalLink href={txnLink} className="text-th-active">
              VIEW
            </ExternalLink>
          )}
        </div>
      </div>
      {showCongestionMsg && status === 'loading' && (
        <div className="mt-2 text-xs">
          Your execution price is fixed but HyperEVM maybe congested right now.
          Searching for the next available block.
        </div>
      )}
    </div>
  )
}
